/* Vacento Homepage JS — vanilla, no dependencies */
(function() {
  'use strict';

  /* ——— Hero Slideshow ——— */
  function initHero() {
    var hero = document.querySelector('.vac-hero');
    if (!hero) return;
    var slides = hero.querySelectorAll('.vac-hero__slide');
    var titles = hero.querySelectorAll('.vac-hero__slide-content');
    var navBtns = hero.querySelectorAll('.vac-hero__nav-btn');
    var totalSlides = slides.length;
    var current = 0;
    var timer;

    function goTo(idx) {
      slides[current].classList.remove('is-active');
      if (navBtns[current]) navBtns[current].classList.remove('is-active');
      current = (idx + totalSlides) % totalSlides;
      slides[current].classList.add('is-active');
      if (navBtns[current]) navBtns[current].classList.add('is-active');
      // reset fill animation
      if (navBtns[current]) {
        var fill = navBtns[current].querySelector('.vac-hero__nav-fill');
        if (fill) { fill.style.animation = 'none'; fill.offsetHeight; fill.style.animation = ''; }
      }
    }

    function start() {
      clearInterval(timer);
      timer = setInterval(function() { goTo(current + 1); }, 7000);
    }

    navBtns.forEach(function(btn, i) {
      btn.addEventListener('click', function() { goTo(i); start(); });
    });

    goTo(0);
    start();
  }

  /* ——— Product Row Carousel ——— */
  function initRow(row) {
    var track = row.querySelector('.vac-row__track');
    var prevBtn = row.querySelector('.vac-arrow--prev');
    var nextBtn = row.querySelector('.vac-arrow--next');
    var fill = row.querySelector('.vac-row__progress-fill');
    var nowEl = row.querySelector('.vac-row__counter-now');
    if (!track) return;

    var cell = track.querySelector('.vac-row__cell');
    var total = track.querySelectorAll('.vac-row__cell').length;
    var visible = 3;
    var maxIdx = Math.max(0, total - visible);

    function cellWidth() {
      return cell ? cell.getBoundingClientRect().width + 24 : 0;
    }

    function getIdx() {
      var w = cellWidth();
      return w ? Math.round(track.scrollLeft / w) : 0;
    }

    function updateUI(idx) {
      var clamped = Math.max(0, Math.min(idx, maxIdx));
      if (prevBtn) prevBtn.disabled = clamped === 0;
      if (nextBtn) nextBtn.disabled = clamped >= maxIdx;
      if (fill) fill.style.width = ((clamped + 1) / (maxIdx + 1) * 100) + '%';
      if (nowEl) nowEl.textContent = String(clamped + 1).padStart(2, '0');
    }

    if (prevBtn) prevBtn.addEventListener('click', function() {
      var idx = getIdx();
      track.scrollTo({ left: (idx - 1) * cellWidth(), behavior: 'smooth' });
      setTimeout(function() { updateUI(getIdx()); }, 400);
    });
    if (nextBtn) nextBtn.addEventListener('click', function() {
      var idx = getIdx();
      track.scrollTo({ left: (idx + 1) * cellWidth(), behavior: 'smooth' });
      setTimeout(function() { updateUI(getIdx()); }, 400);
    });

    track.addEventListener('scroll', function() { updateUI(getIdx()); }, { passive: true });
    updateUI(0);
  }

  function initAllRows() {
    document.querySelectorAll('.vac-row').forEach(initRow);
  }

  /* ——— Product Card Hover (alt image) ——— */
  function initCards() {
    document.querySelectorAll('.vac-card').forEach(function(card) {
      card.addEventListener('mouseenter', function() {
        var alt = card.querySelector('.vac-card__img--alt');
        if (alt) alt.style.opacity = '1';
      });
      card.addEventListener('mouseleave', function() {
        var alt = card.querySelector('.vac-card__img--alt');
        if (alt) alt.style.opacity = '0';
      });
    });
  }

  /* ——— Reviews Tab ——— */
  function initReviews() {
    var section = document.querySelector('.vac-reviews');
    if (!section) return;
    var pills = section.querySelectorAll('.vac-reviews__pill');
    var quotes = section.querySelectorAll('.vac-reviews__quote-item');

    pills.forEach(function(pill, i) {
      pill.addEventListener('click', function() {
        pills.forEach(function(p) { p.classList.remove('is-active'); });
        quotes.forEach(function(q) { q.style.display = 'none'; });
        pill.classList.add('is-active');
        if (quotes[i]) quotes[i].style.display = 'block';
      });
    });

    if (pills[0]) pills[0].click();
  }

  /* ——— Quick Add ——— */
  function initQuickAdd() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.vac-card__add');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function() {
        btn.textContent = '✓ Added';
        btn.classList.add('is-added');
        // update cart count if possible
        fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
          var counts = document.querySelectorAll('.vac-cart-count, .cart-count');
          counts.forEach(function(el){ el.textContent = cart.item_count; });
        });
        setTimeout(function() { btn.textContent = 'Quick add'; btn.classList.remove('is-added'); }, 2000);
      }).catch(function() { btn.textContent = 'Quick add'; });
    });
  }

  /* ——— Init ——— */
  function init() {
    initHero();
    initAllRows();
    initCards();
    initReviews();
    initQuickAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
